import { Reducer } from 'redux';
import { VideoActionTypes, VideoState } from './action';

const initialState: VideoState = {
  issueTags: [],
  hasFavoriteList: [],
  productList: [],
  singleProduct: {},
};
const { RANDOM_ISSUE_TAGS_REDUCER, HAS_FAVORITE_REDUCER, PRODUCT_LIST_REDUCER } = VideoActionTypes;
const reducer: Reducer<VideoState> = (state = initialState, action) => {
  switch (action.type) {
    case RANDOM_ISSUE_TAGS_REDUCER: {
      const { data } = action;
      return {
        ...state,
        issueTags: data,
      };
    }
    case HAS_FAVORITE_REDUCER: {
      const { data } = action;
      return {
        ...state,
        hasFavoriteList: data,
      };
    }
    case PRODUCT_LIST_REDUCER: {
      const { data } = action;
      return {
        ...state,
        productList: data,
        singleProduct: { isDefault: true, patientPackageType: 3, ...(data[0] || {}) },
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as VideoReducer };
